import { type GoogleSignInError, GoogleSignInErrorSchema } from '@sbc/domain-models/admin';

const MESSAGES: Record<GoogleSignInError, string> = {
  unavailable: 'Google sign-in is not available right now. Use your email and password.',
  domain: 'Use your @seoulbeautyclub.com Google account.',
  no_access:
    'This Google account has no access to the agents admin. Ask an admin to add or reactivate you.',
  failed: 'Google sign-in did not complete. Please try again.',
};

export function parseGoogleSignInError(value: unknown): GoogleSignInError | undefined {
  return GoogleSignInErrorSchema.safeParse(value).data;
}

export function googleSignInMessage(error: GoogleSignInError): string {
  return MESSAGES[error];
}

export function googleSignInHref(redirect: string | undefined): string {
  if (!redirect) return '/api/auth/google';
  return `/api/auth/google?${new URLSearchParams({ redirect }).toString()}`;
}
